//REDUX-TOOLKIT
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface State {
    steps: any
    userStatus?: boolean
    userStatusLoading?: boolean
}

const initialState: State = {
    steps: null,
    userStatus: false,
    userStatusLoading: false,
}

const slice = createSlice({
    name: "profile",
    initialState,
    reducers: {
        setSteps: (state, action: PayloadAction<any>) => {
            return { ...state, steps: action.payload }
        },
        setUserStatus: (state, action: PayloadAction<any>) => {
            return { ...state, userStatus: action.payload }
        },
        setUserStatusLoading: (state, action: PayloadAction<any>) => {
            return { ...state, userStatusLoading: action.payload }
        },
    },
})

export const { setSteps, setUserStatus, setUserStatusLoading } = slice.actions
export const selectProfileSteps = (state: { profile: State }) =>
    state.profile.steps
export const selectProfileSelector = (state: { profile: State }) =>
    state.profile
export default slice.reducer
